// extracted by mini-css-extract-plugin
export var discard = "_4b-3";
export var muiTooltipTooltip = "_4b-5";
export var notificationBar = "_4b-2";
export var saveButtonHoverSlotWrapper = "_4b-4";
export var show = "_4b-1";
export var spacer = "_4b-0";